import { END_GAME, EVENT_WINDOW } from '../game/constants/hud';
import type { MatchInfoState } from '../game/world';

/** Hours wrap at 24 with nothing above shown — safe because both announcement horizons are under nine hours, so a longer one would need a different format. */
export function formatDuration(ms: number): string {
  const clamped = Math.max(0, ms);
  const hours = Math.floor(clamped / 3_600_000) % 24;
  const minutes = Math.floor(clamped / 60_000) % 60;
  const seconds = Math.floor(clamped / 1000) % 60;

  if (hours > 0) return `${String(hours)}:${pad(minutes)}:${pad(seconds)}`;
  if (minutes > 0) return `${pad(minutes)}:${pad(seconds)}`;
  if (seconds > 0) return pad(seconds);
  return '';
}

export function matchOverAnnouncement(info: MatchInfoState, selfTeam: number): string {
  const winningTeam = info.won ? selfTeam : 1 - selfTeam;
  const winner = winningTeam === 0 ? END_GAME.teamLabels[0] : END_GAME.teamLabels[1];
  const rank = `Rank ${String(info.rank)} of ${String(info.maxPlayers)}.`;
  return info.gainedCredits === 0
    ? `${winner} Team Wins. ${rank}`
    : `${winner} Team Wins. ${rank} +${String(info.gainedCredits)} credits.`;
}

export function eventAnnouncement(
  startAt: number | null,
  endAt: number | null,
  now: number,
): { label: string; countdown: string } {
  if (startAt !== null && now < startAt && startAt - now < EVENT_WINDOW.announceHorizonMs) {
    return { label: EVENT_WINDOW.pendingLabel, countdown: formatDuration(startAt - now) };
  }
  if (startAt !== null && endAt !== null && now > startAt && now < endAt) {
    return { label: EVENT_WINDOW.runningLabel, countdown: formatDuration(endAt - now) };
  }
  return { label: '', countdown: '' };
}

function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
